<template>
  <div class="ui-ai-conversation-examples">
    <UIButton
      v-for="example in examples"
      :key="example"
      :label="example"
      :disabled
      variant="secondary"
      fill="outlined"
      size="xs"
      @click="handleClick(example)"
    />
  </div>
</template>

<script setup lang="ts">
import UIButton from '../Button/Button.vue'

type Props = {
  examples: string[]
  disabled?: boolean
}

type Emits = {
  (e: 'click:example', message: string): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const handleClick = (data: string) => {
  emit('click:example', data)
}
</script>

<style>
.ui-ai-conversation-examples {
  @apply max-w-full;
  @apply flex flex-wrap justify-center gap-2;

  .ui-button {
    @apply max-w-full;
    @apply rounded-full;

    .ui-button__label {
      @apply inline;
      @apply truncate;
    }
  }
}
</style>
